import { render, staticRenderFns } from "./TransactionList.vue?vue&type=template&id=715d217f&"
import script from "./TransactionList.vue?vue&type=script&lang=ts&"
export * from "./TransactionList.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports